import { SubscriptionProductType } from '../../../../../services/exports/Constants';

export default {
  title: 'Novo produto',
  fields: {
    type: {
      label: 'Tipo de produto',
      options: {
        [SubscriptionProductType.Plan]: 'Plano',
        [SubscriptionProductType.AddOn]: 'Complemento',
        [SubscriptionProductType.GoogleAdsPlan]: 'Plano Google Ads',
      },
    },
    name: {
      label: 'Nome interno',
      placeholder: 'Introduza o nome interno do produto',
    },
    public_name: {
      label: 'Nome público',
      placeholder: 'Introduza o nome público do produto',
    },
    description: {
      label: 'Descrição',
    },
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
  },
  feedback: {
    missing_info: 'Informação em falta',
  },
  toasts: {
    plan_got_created: 'Produto criado',
    plan_got_updated: 'Produto atualizado',
  },
};
